// @flow
import ContentOpenWith from '../ContentOpenWith';

export const basic = {};

export default {
    title: 'Elements/ContentOpenWith',
    component: ContentOpenWith,
    args: {
        features: global.FEATURE_FLAGS,
        rootFolderId: global.FOLDER_ID,
        token: global.TOKEN,
    },
};
